import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/lib/apiClient";
import { queryKeys } from "@/lib/query";
import type { MerchantItem } from "@/types/api/merchant";

export function useMerchantById(id: string | undefined) {
  return useQuery({
    queryKey: queryKeys.merchants.detail(id ?? ""),
    queryFn: () => apiClient.getData<MerchantItem>(`/merchants/${id}`),
    enabled: !!id,
  });
}
